/**
 * Responsibility: what "which cards to screen" consists of.
 *
 * Its own module because three places need it - the control that sets it,
 * the badges that display it and the page that applies it - and a
 * component file that also exports values breaks fast refresh.
 *
 * The default is where the board starts, which is also what "no filters"
 * means: era and language always have a value, so "unset" for them is the
 * starting value rather than empty.
 */
import type { CardEra, CardLanguage } from '../../api/client';

export type DiscoveryFilters = {
  era: CardEra;
  language: CardLanguage;
  /** Minimum PSA 10 population: how much evidence a gem price needs. */
  floor: number;
  /** Narrows the rows that came back, by name or set. */
  keywords: string;
};

export const DEFAULT_FILTERS: DiscoveryFilters = {
  era: 'MODERN',
  language: 'EN',
  floor: 25,
  keywords: '',
};

/** How many filters differ from where the board starts. */
export function activeCount(filters: DiscoveryFilters): number {
  return (Object.keys(DEFAULT_FILTERS) as (keyof DiscoveryFilters)[]).filter(
    (key) => filters[key] !== DEFAULT_FILTERS[key],
  ).length;
}
